import { Controller } from 'stimulus'

export default class AnnotationKeyboardHintController extends Controller {
  static values = { delay: Number }

  static classes = ['hidden']

  connect() {
    // Hide on touch devices
    if (this.isTouchDevice()) {
      this.element.style.display = 'none'
      return
    }

    // Start hidden
    this.element.classList.add(this.hiddenClass)

    // Show after delay
    this.showTimeout = setTimeout(() => {
      this.show()
    }, this.delayValue)

    // Listen for annotation mode changes
    this.handleModeChange = this.handleModeChange.bind(this)
    document.addEventListener('annotation:mode-change', this.handleModeChange)

    // Listen for keyboard shortcuts
    this.handleKeydown = this.handleKeydown.bind(this)
    document.addEventListener('keydown', this.handleKeydown)
  }

  disconnect() {
    if (this.showTimeout) clearTimeout(this.showTimeout)
    document.removeEventListener('keydown', this.handleKeydown)
    document.removeEventListener('annotation:mode-change', this.handleModeChange)
  }

  // eslint-disable-next-line class-methods-use-this
  handleKeydown(event) {
    // Ignore if typing in input fields
    if (event.target.matches('input, textarea, [contenteditable]')) {
      return
    }

    // Ignore if modifier keys are pressed
    if (event.ctrlKey || event.metaKey || event.altKey) {
      return
    }

    if (event.key.toLowerCase() === 'n' && window.annotationManager) {
      event.preventDefault()
      window.annotationManager.enterAnnotationMode()
    } else if (event.key === 'Escape' && window.annotationManager) {
      event.preventDefault()
      window.annotationManager.exitAnnotationMode()
    }
  }

  handleModeChange(event) {
    if (event.detail && event.detail.mode === 'annotate') {
      this.hide()
    } else {
      this.show()
    }
  }

  show() {
    this.element.classList.remove(this.hiddenClass)
  }

  hide() {
    this.element.classList.add(this.hiddenClass)
  }

  // eslint-disable-next-line class-methods-use-this
  isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0
  }
}
